import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XDiv, XInput} from "../Layout/Layout";
import {FormManagerContext} from "../Form/FormManagerContext";
import Calendar from "./Calendar";
import ReactDOM from "react-dom";
import PopOver from "../Modal/PopOver";
var jalaali = require('jalaali-js');

const otherRoot = document.getElementById('other-root');

class   DatePicker extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.el=React.createRef();
        this.input=React.createRef();
        this.calendar=React.createRef();
        this.div=React.createRef();


        this.HfocusInput = this.focusInput.bind(this);
        this.HchangeInput = this.changeInput.bind(this);
        this.HclosingDrop = this.closingDrop.bind(this);
        this.HselectDate = this.selectDate.bind(this);
        this.HfocusOutInput = this.focusOutInput.bind(this);

        this.state={isShow:false};
        this.popOver=null;
        this.props=props;
    }

    setValue(val){
        this.input.current.value=val;
        this.calendar.current.setDate(val);
    }

    setDateTimeValue(val){
        let d1=new Date(val);
        /*
       let yy=d1.getFullYear();
       let mm=d1.getMonth();
       let dd=d1.getDay();
       let arr=this.calendar.current.pd.gregorian_to_jalali(yy,mm,dd);
       if(arr.length===3){
           let s=arr[0]+"/"+arr[1]+"/"+arr[2];
           this.input.current.value=s;
           this.calendar.current.setDate(s);
       }*/
        let  jd=jalaali.toJalaali(d1);
        if(jd){
            let s=jd.jy+"/"+jd.jm+"/"+jd.jd;
            this.input.current.value=s;
            this.calendar.current.setDate(s);
        }
    }

    getValue(){
        return this.input.current.value;
    }

    focusInput(e){
        if (e.currentTarget === e.target) {
            if (!this.state.isShow) {
                e.preventDefault();
                e.stopPropagation();
                setTimeout(function() {
                    if (!this.state.isShow) {
                        this.showDrop();
                        this.popOver.showDrop();
                    }
                }.bind(this), 250);
                return false;
            }
        }
    }

    focusOutInput(e){
        if (e.currentTarget === e.target) {
            let plugin=this;
            let target = e.relatedTarget;
            if(target==null) target = e.explicitOriginalTarget ;
            if(Boolean(target)) {
                setTimeout(function () {
                    if (!plugin.div.current.contains(target)) {
                        if (plugin.state.isShow) plugin.closeDrop();
                    }
                }, 200);
            }
        }
    }

    changeInput(evt){
        let _date=this.input.current.value;
        this.calendar.current.setDate(_date);
        this.showDrop();
        let f = this.props.onChange;
        if (f !== null) {
            if (f instanceof Function) {
                f(_date);
            }
        }
        evt.preventDefault();
    }

    showDrop  () {
        let fmState = this.context;
        if(!fmState.isReadOnly) {
            this.showing();
        }
    };

    selectDate () {
        let d=this.calendar.current.getDate();
        this.input.current.value=d;
        this.closeDrop();
        let f = this.props.onChange;
        if (f !== null) {
            if (f instanceof Function) {
                f(d);
            }
        }
    };

    closeDrop  () {
        document.removeEventListener('mousedown', this.HclosingDrop);
        document.removeEventListener('ontouchstart', this.HclosingDrop);
        if(this.state.isShow) {
            this.setState({isShow : false}) ;
            let f = this.props.closeCallback;
            if (f !== null) {
                if (f instanceof Function) {
                    f();
                }
            }
        }
    };

    closingDrop  (event) {
        if (this.isAlive) {
            if (this.div.current.contains(event.target)) {
            } else {
                let x = 0, y = 0;
                if (event) {
                    let bTouch = false;
                    if (event.touches) {
                        if (event.touches.length > 0) {
                            bTouch = true;
                        }
                    }
                    if (bTouch) {
                        x = event.touches[0].clientX;
                        y = event.touches[0].clientY;
                    } else {
                        x = event.clientX;
                        y = event.clientY;
                    }
                }
                if (window.outerWidth <= x) {
                    return true;
                } else if (window.outerHeight <= y) {
                    return true;
                } else {
                    this.closeDrop();
                }
            }
        }
    };

    showing () {
        document.addEventListener('mousedown', this.HclosingDrop,true);
        document.addEventListener('ontouchstart', this.HclosingDrop,true);
        this.setState({isShow : true}) ;
    };

    componentDidMount() {
        this.popOver=new PopOver(this.el.current,{Btn:this.input.current,Div:this.div.current,isRelative:false,useCapture:true});
    }

    renderPortal() {
        const {
            value,
            currentDate,
        } = this.props;

        let d="datepicker";
        if(this.state.isShow){
            d= d+" open";
        }

        return <XDiv className={d} eleRef={this.div}>
            <Calendar date={value} currentDate={currentDate} ref={this.calendar} selectCallback={this.HselectDate} />
        </XDiv>;
    }

    render() {
        const {
            className,
            containerClassName
        } = this.props;

        let fmState = this.context;

        return (
            <XDiv className={containerClassName}  eleRef={this.el}>
                <XInput type="text"  eleRef={this.input} onFocus={this.HfocusInput}
                            onBlur={this.HfocusOutInput} onChange={this.HchangeInput}
                        className={`form-control ${className}`} readonly={fmState.isReadOnly} />
                    {ReactDOM.createPortal(this.renderPortal(), otherRoot)}
            </XDiv>
        )
    }

    componentWillUnmount() {
        this.destroy();
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }
        this.closeDrop();
        this.isAlive = false;
    }
}

DatePicker.propTypes = {
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    onChange: PropTypes.func,
    currentDate: PropTypes.string,
    value: PropTypes.string,
    local: PropTypes.string,
    closeCallback: PropTypes.func,
    state: PropTypes.oneOf(['top', 'bottom', 'right', 'left', 'topBottom']),
    padding: PropTypes.number,
    isAnchor: PropTypes.bool,
};

DatePicker.defaultProps = {
    className:"",
    containerClassName:"",
    currentDate:'',
    value:'',
    local:'fa',
    state:"top",
    padding:25,
    isAnchor:true,
};

DatePicker.contextType = FormManagerContext;

export default DatePicker;
